import type { CacheConfigMode } from '@cli-types/next-adapter/init.js'

export function resolveCacheConfigMode(nextMajorVersion: number): CacheConfigMode | null {
  if (nextMajorVersion >= 16) return 'cache-components'
  if (nextMajorVersion >= 15) return 'experimental-use-cache'
  return null
}
